// 'use client';
import React, { useState } from "react";
import { Input } from "@chakra-ui/react";
import "./taxconfig.css";

const TaxConfig = ({ formValues, setFormValues }) => {
  const [buyminmax, setbuyminmax] = useState({
    liq: 0,
    markfee: 0,
  });
  const [sellminmax, setsellminmax] = useState({
    liq: 0,
    markfee: 0,
  });
  return (
    <div className="main-config">
      <div className="linethrough">TAX CONFIGS</div>
      <div className="config-holder">
        <div className="buymax">
          <div className="inputs">
            <div className="inp1">
              <label htmlFor="tokenname">
                Liq. Fee <span className="astrick">*</span>
              </label>
              <Input
                placeholder="0-6%"
                size="sm"
                type="number"
                min={0}
                max={6 - buyminmax.markfee}
                value={formValues.liqFee}
                onChange={(e) => {
                  setbuyminmax({
                    ...buyminmax,
                    liq: Math.max(
                      0,
                      Math.min(6 - buyminmax.markfee, e.target.value)
                    ),
                  });
                  setFormValues({
                    ...formValues,
                    liqFee: Math.max(
                      0,
                      Math.min(6 - buyminmax.markfee, e.target.value)
                    ),
                  });
                }}
              />
            </div>
            <div className="inp2">
              <label htmlFor="tokensymbol">
                Marketing Fee <span className="astrick">*</span>
              </label>
              <Input
                placeholder="0-6%"
                size="sm"
                type="number"
                min={0}
                max={6 - buyminmax.liq}
                value={formValues.marketingFee}
                onChange={(e) => {
                  setbuyminmax({
                    ...buyminmax,
                    markfee: Math.max(
                      0,
                      Math.min(6 - buyminmax.liq, e.target.value)
                    ),
                  });
                  setFormValues({
                    ...formValues,
                    marketingFee: Math.max(
                      0,
                      Math.min(6 - buyminmax.liq, e.target.value)
                    ),
                  });
                }}
              />
            </div>
          </div>
          <div className="linethroughmax">
            <span>BUY TAX MAX 6</span></div>
        </div>
        <div className="sellmax">
          <div className="inputs">
            <div className="inp3">
              <label htmlFor="totalsupply">
                Liq. Fee <span className="astrick">*</span>
              </label>
              <Input
                placeholder="0-6%"
                size="sm"
                type="number"
                min={0}
                max={6 - sellminmax.markfee}
                value={formValues.liqFee2}
                onChange={(e) => {
                  setsellminmax({
                    ...sellminmax,
                    liq: Math.max(
                      0,
                      Math.min(6 - sellminmax.markfee, e.target.value)
                    ),
                  });
                  setFormValues({
                    ...formValues,
                    liqFee2: Math.max(
                      0,
                      Math.min(6 - sellminmax.markfee, e.target.value)
                    ),
                  });
                }}
              />
            </div>
            <div className="inp4">
              <label htmlFor="totalsupply">
                Marketing Fee <span className="astrick">*</span>
              </label>
              <Input
                placeholder="0-6%"
                size="sm"
                type="number"
                min={0}
                max={6 - sellminmax.liq}
                value={formValues.marketingFee2}
                onChange={(e) => {
                  setsellminmax({
                    ...sellminmax,
                    markfee: Math.max(
                      0,
                      Math.min(6 - sellminmax.liq, e.target.value)
                    ),
                  });
                  setFormValues({
                    ...formValues,
                    marketingFee2: Math.max(
                      0,
                      Math.min(6 - sellminmax.liq, e.target.value)
                    ),
                  });
                }}
              />
            </div>
          </div>
          <div className="linethroughmax">
            <span>SELL TAX MAX 6</span></div>
        </div>
      </div>
    </div>
  );
};

export default TaxConfig;
